class AddEditSimulationDataModelController {
    constructor(SimulationDataServiceApi, toastr, ScriptInjectionService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                action: 'Create'
            };
            this.data = {
                simulationDataModel: null,
                simulationDataTypes: null
            };
            this.data.simulationDataModel = angular.copy(this.resolve.simulationDataModel);
            this.data.simulationDataTypes = angular.copy(this.resolve.simulationDataTypes);
            if (_.isNil(this.data.simulationDataTypes) || this.data.simulationDataTypes.length === 0) {
                this.toastr.warning('Cannot add or update any simulation data when no types are defined. Add some types in the database first.', 'No Simulation Data Types Found');
                this.cancel();
            }
            if (this.data.simulationDataModel === null || angular.isUndefined(this.data.simulationDataModel.Name)) {
                this.data.simulationDataModel = {
                    Id: -1,
                    Name: '',
                    Sequence: 1,
                    SimulationDataTypeId: this.data.simulationDataTypes[0].Id,
                    SimulationDataType: this.data.simulationDataTypes[0],
                    SimulationDataLibraryId: -1,
                    SimulationDataLibrary: null,
                    DefaultJson: null,
                    DefaultXml: null,
                    Description: null,
                    IsDeleted: false,
                    Locked: false,
                    ModelUid: null,
                    Path: ''
                };
                this.state.action = 'Create';
            }
            else {
                this.state.action = 'Update';
            }
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.onTypeChange = (newType) => {
            // Keep the Id and actual object in sync
            this.data.simulationDataModel.SimulationDataTypeId = newType.Id;
        };
        this.save = () => {
            if (this.ScriptInjectionService.isInjectedScript(this.data.simulationDataModel.Name)) {
                this.toastr.error('Name contains illegal characters');
                return;
            }
            this.SimulationDataServiceApi.saveModel(this.data.simulationDataModel).then((response) => {
                if (!angular.isUndefined(response)) {
                    this.resolve.simulationDataModel = this.data.simulationDataModel;
                    this.close({ $value: this.state.action + 'd' });
                }
                else {
                    this.toastr.error('Please check all details are correct', 'Error Saving');
                }
            });
        };
        this.SimulationDataServiceApi = SimulationDataServiceApi;
        this.toastr = toastr;
        this.ScriptInjectionService = ScriptInjectionService;
    }
}
angular.module('app').component('addEditSimulationDataModelModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/SimulationData/admin/add-edit-simulation-data-model-modal.tpl.html',
    controllerAs: 'vm',
    controller: AddEditSimulationDataModelController
});
